import React from 'react';
import CertificationSelector from './CertificationSelector';

const AppHeader = ({ 
  selectedCertification, 
  cards, 
  currentCardIndex, 
  shuffled, 
  onShuffle, 
  onReset,
  certifications,
  onCertificationSelect
}) => {
  return (
    <header className="app-header">
      <div className="header-top">
        <h1>
          {selectedCertification ? selectedCertification.name : 'Azure Certification Flashcards'}
        </h1>
        {selectedCertification && cards.length > 0 && (
          <div className="app-controls">
            <div className="stats">
              <span className="card-counter">
                {currentCardIndex + 1} / {cards.length}
              </span>
              <span className="progress-text">
                {Math.round(((currentCardIndex + 1) / cards.length) * 100)}% Complete
              </span>
            </div>
            <div className="control-buttons">
              <button className="control-button" onClick={onShuffle}>
                {shuffled ? '↻ Reset Order' : '🔀 Shuffle Cards'}
              </button>
              <button className="control-button" onClick={onReset}>
                ⏮ Start Over
              </button>
            </div>
          </div>
        )}
      </div>
      
      {/* Certification Selection */}
      <CertificationSelector 
        certifications={certifications}
        selectedCertification={selectedCertification}
        onCertificationSelect={onCertificationSelect}
      />
    </header>
  );
};

export default AppHeader;
